import { render, staticRenderFns } from "./DetailAkun.vue?vue&type=template&id=1af729a3&scoped=true"
import script from "./DetailAkun.vue?vue&type=script&lang=js"
export * from "./DetailAkun.vue?vue&type=script&lang=js"
import style0 from "./DetailAkun.vue?vue&type=style&index=0&id=1af729a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af729a3",
  null
  
)

export default component.exports